import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Lackfertighaus - Professionelle Ausbauarbeiten</title>
        <meta name="description" content="Lackfertighaus - Professionelle Ausbauarbeiten und Finishing-Lösungen in Deutschland. Hochwertige Handwerkskunst für Ihr Zuhause." />
        <link rel="canonical" href="https://lackfertighaus.com/terms-conditions/" />
      </Helmet>

      <div className="policy-page">
      <div className="policy-container">
        <h1>Allgemeine Geschäftsbedingungen</h1>
        <p className="last-updated">Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE')}</p>

        <section>
          <h2>1. Geltungsbereich</h2>
          <p>
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Geschäftsbeziehungen zwischen 
            Lackfertighaus (nachfolgend "Auftragnehmer" genannt) und seinen Kunden (nachfolgend "Auftraggeber" 
            genannt) im Bereich professioneller Ausbauarbeiten, Finishing-Lösungen und handwerklicher 
            Dienstleistungen in Deutschland.
          </p>
          <p>
            Abweichende, entgegenstehende oder ergänzende Geschäftsbedingungen des Auftraggebers werden 
            nur dann Vertragsbestandteil, wenn und soweit wir ihrer Geltung ausdrücklich schriftlich 
            zugestimmt haben.
          </p>
        </section>

        <section>
          <h2>2. Vertragsschluss</h2>
          
          <h3>2.1 Angebot und Annahme</h3>
          <p>
            Die Präsentation unserer Dienstleistungen auf unserer Website stellt kein rechtlich bindendes 
            Angebot dar, sondern eine Aufforderung zur Abgabe eines Angebots. Durch Absenden einer Anfrage 
            über unser Kontaktformular oder per E-Mail gibt der Auftraggeber ein verbindliches Angebot ab.
          </p>

          <h3>2.2 Auftragsbestätigung</h3>
          <p>
            Der Vertrag kommt zustande durch:
          </p>
          <ul>
            <li>Unsere schriftliche Auftragsbestätigung</li>
            <li>Übersendung eines schriftlichen Angebots und dessen Annahme durch den Auftraggeber</li>
            <li>Beginn der Ausführung der beauftragten Leistungen</li>
          </ul>

          <h3>2.3 Vertragssprache</h3>
          <p>
            Die für den Vertragsschluss zur Verfügung stehende Sprache ist Deutsch.
          </p>
        </section>

        <section>
          <h2>3. Leistungsumfang</h2>
          
          <h3>3.1 Dienstleistungen</h3>
          <p>
            Wir bieten professionelle Dienstleistungen in folgenden Bereichen:
          </p>
          <ul>
            <li>Ausbauarbeiten für Wohn- und Geschäftsräume</li>
            <li>Finishing-Arbeiten und Oberflächenbehandlung</li>
            <li>Lackier- und Beschichtungsarbeiten</li>
            <li>Innenausbau und Renovierungsarbeiten</li>
            <li>Qualitätskontrollen und Nachbesserungen</li>
            <li>Beratungsleistungen für Bauprojekte</li>
          </ul>

          <h3>3.2 Leistungsbeschreibung</h3>
          <p>
            Der konkrete Leistungsumfang ergibt sich aus der jeweiligen Auftragsbestätigung bzw. 
            dem Angebot. Änderungen und Ergänzungen bedürfen der Schriftform.
          </p>

          <h3>3.3 Teilleistungen</h3>
          <p>
            Wir sind berechtigt, Teilleistungen zu erbringen, sofern dies dem Auftraggeber zumutbar ist 
            und die Teilleistung für ihn von Interesse ist.
          </p>
        </section>

        <section>
          <h2>4. Preise und Zahlungsbedingungen</h2>
          
          <h3>4.1 Preise</h3>
          <p>
            Alle Preise verstehen sich in Euro und enthalten die gesetzliche Mehrwertsteuer. 
            Die Preise gelten ab Geschäftssitz. Zusätzliche Kosten wie Fahrtkosten, Materialkosten 
            oder besondere Entsorgungskosten werden gesondert ausgewiesen und berechnet.
          </p>

          <h3>4.2 Zahlungsbedingungen</h3>
          <p>
            Soweit nichts anderes vereinbart ist, gelten folgende Zahlungsbedingungen:
          </p>
          <ul>
            <li>Bei Aufträgen bis 5.000 Euro: Zahlung innerhalb von 14 Tagen nach Rechnungsstellung</li>
            <li>Bei Aufträgen über 5.000 Euro: 30% Anzahlung bei Auftragserteilung, 40% bei Beginn der Arbeiten, 30% nach Abnahme</li>
            <li>Bei langfristigen Projekten: Abschlagszahlungen nach Baufortschritt</li>
          </ul>

          <h3>4.3 Zahlungsverzug</h3>
          <p>
            Bei Zahlungsverzug berechnen wir Verzugszinsen in Höhe von 9 Prozentpunkten über dem 
            Basiszinssatz. Die Geltendmachung eines höheren Verzugsschadens bleibt vorbehalten.
          </p>

          <h3>4.4 Aufrechnung und Zurückbehaltungsrecht</h3>
          <p>
            Der Auftraggeber ist nur berechtigt, mit unbestrittenen oder rechtskräftig festgestellten 
            Forderungen aufzurechnen. Ein Zurückbehaltungsrecht kann nur ausgeübt werden, soweit es 
            auf demselben Vertragsverhältnis beruht.
          </p>
        </section>

        <section>
          <h2>5. Ausführungsfristen und Termine</h2>
          
          <h3>5.1 Leistungszeit</h3>
          <p>
            Die Leistungszeit wird in der Auftragsbestätigung angegeben. Bindende Fertigstellungstermine 
            bedürfen der ausdrücklichen schriftlichen Bestätigung.
          </p>

          <h3>5.2 Verzögerungen</h3>
          <p>
            Verzögert sich die Ausführung aus Gründen, die wir nicht zu vertreten haben (z.B. höhere Gewalt, 
            Arbeitskampf, behördliche Maßnahmen, Verzögerungen durch den Auftraggeber oder Dritte), 
            verlängert sich die Ausführungsfrist angemessen.
          </p>

          <h3>5.3 Leistungshindernisse</h3>
          <p>
            Über erkennbare Leistungshindernisse werden wir den Auftraggeber unverzüglich informieren. 
            Der Auftraggeber ist verpflichtet, die für die Ausführung erforderlichen Vorleistungen 
            rechtzeitig zu erbringen.
          </p>
        </section>

        <section>
          <h2>6. Mitwirkungspflichten des Auftraggebers</h2>
          <p>
            Der Auftraggeber verpflichtet sich:
          </p>
          <ul>
            <li>Die Baustelle rechtzeitig zugänglich zu machen und vorzubereiten</li>
            <li>Erforderliche behördliche Genehmigungen einzuholen</li>
            <li>Für ausreichende Strom- und Wasserversorgung zu sorgen</li>
            <li>Wertgegenstände und empfindliche Einrichtungen zu schützen oder zu entfernen</li>
            <li>Uns über besondere Gefahren oder Risiken zu informieren</li>
            <li>Bei Verzögerungen oder Behinderungen unverzüglich zu informieren</li>
          </ul>
        </section>

        <section>
          <h2>7. Abnahme der Leistungen</h2>
          
          <h3>7.1 Abnahmepflicht</h3>
          <p>
            Der Auftraggeber ist verpflichtet, die erbrachten Leistungen nach Fertigstellung abzunehmen, 
            sofern nicht nach der Beschaffenheit des Werkes die Abnahme ausgeschlossen ist.
          </p>

          <h3>7.2 Abnahmefiktion</h3>
          <p>
            Die Abnahme gilt als erfolgt, wenn:
          </p>
          <ul>
            <li>Der Auftraggeber die Leistung entgegengenommen hat und 12 Werktage vergangen sind</li>
            <li>Der Auftraggeber mit der Zahlung der Vergütung in Verzug ist</li>
            <li>Der Auftraggeber die Räumlichkeiten in Gebrauch nimmt</li>
          </ul>

          <h3>7.3 Mängelrüge</h3>
          <p>
            Offensichtliche Mängel sind bei der Abnahme oder binnen 14 Tagen schriftlich zu rügen. 
            Versteckte Mängel sind unverzüglich nach Entdeckung schriftlich anzuzeigen.
          </p>
        </section>

        <section>
          <h2>8. Gewährleistung</h2>
          
          <h3>8.1 Gewährleistungsfrist</h3>
          <p>
            Die Gewährleistungsfrist für unsere Leistungen beträgt 2 Jahre ab Abnahme, soweit nicht 
            gesetzlich längere Fristen vorgeschrieben sind. Für Mängel an Bauwerken beträgt die 
            Gewährleistungsfrist 5 Jahre.
          </p>

          <h3>8.2 Mängelbeseitigung</h3>
          <p>
            Bei berechtigten Mängelrügen sind wir nach unserer Wahl zur Nachbesserung oder Ersatzlieferung 
            berechtigt. Schlägt die Nachbesserung fehl, kann der Auftraggeber nach seiner Wahl Minderung 
            verlangen oder vom Vertrag zurücktreten.
          </p>

          <h3>8.3 Ausschluss der Gewährleistung</h3>
          <p>
            Die Gewährleistung ist ausgeschlossen bei:
          </p>
          <ul>
            <li>Natürlicher Abnutzung</li>
            <li>Unsachgemäßer Behandlung oder Nutzung</li>
            <li>Eigenmächtigen Änderungen durch den Auftraggeber</li>
            <li>Nichtbeachtung von Pflege- und Wartungshinweisen</li>
            <li>Verwendung ungeeigneter Materialien durch den Auftraggeber</li>
          </ul>
        </section>

        <section>
          <h2>9. Haftung</h2>
          
          <h3>9.1 Haftungsumfang</h3>
          <p>
            Wir haften unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für die Verletzung 
            von Leben, Körper oder Gesundheit. Für leichte Fahrlässigkeit haften wir nur bei Verletzung 
            wesentlicher Vertragspflichten (Kardinalpflichten). Die Haftung ist in diesem Fall auf 
            den vorhersehbaren, vertragstypischen Schaden begrenzt.
          </p>

          <h3>9.2 Haftungsausschluss</h3>
          <p>
            Die Haftung für mittelbare Schäden, Folgeschäden und entgangenen Gewinn ist ausgeschlossen, 
            soweit nicht zwingend gesetzlich gehaftet wird.
          </p>

          <h3>9.3 Versicherung</h3>
          <p>
            Wir unterhalten eine Betriebshaftpflichtversicherung mit branchenüblichen Deckungssummen.
          </p>
        </section>

        <section>
          <h2>10. Eigentumsvorbehalt</h2>
          <p>
            Gelieferte Materialien bleiben bis zur vollständigen Bezahlung aller Forderungen aus der 
            Geschäftsbeziehung unser Eigentum. Der Auftraggeber ist verpflichtet, die Vorbehaltsware 
            pfleglich zu behandeln.
          </p>
        </section>

        <section>
          <h2>11. Urheberrecht und Nutzungsrechte</h2>
          <p>
            An allen von uns erstellten Entwürfen, Plänen, Zeichnungen und sonstigen Unterlagen behalten 
            wir uns alle Eigentums- und Urheberrechte vor. Diese Unterlagen dürfen ohne unsere 
            ausdrückliche Zustimmung weder kopiert noch Dritten zugänglich gemacht werden.
          </p>
        </section>

        <section>
          <h2>12. Vertraulichkeit</h2>
          <p>
            Beide Parteien verpflichten sich, alle im Rahmen der Geschäftsbeziehung erlangten 
            Informationen vertraulich zu behandeln und nur zur Vertragserfüllung zu verwenden. 
            Diese Verpflichtung besteht auch nach Beendigung des Vertragsverhältnisses fort.
          </p>
        </section>

        <section>
          <h2>13. Kündigung</h2>
          
          <h3>13.1 Ordentliche Kündigung</h3>
          <p>
            Der Vertrag kann von beiden Parteien mit einer Frist von 14 Tagen schriftlich gekündigt werden, 
            soweit noch keine Arbeiten begonnen wurden.
          </p>

          <h3>13.2 Außerordentliche Kündigung</h3>
          <p>
            Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt. 
            Ein wichtiger Grund liegt insbesondere vor bei:
          </p>
          <ul>
            <li>Zahlungsverzug des Auftraggebers trotz Mahnung</li>
            <li>Verletzung wesentlicher Vertragspflichten</li>
            <li>Insolvenz einer Vertragspartei</li>
          </ul>

          <h3>13.3 Folgen der Kündigung</h3>
          <p>
            Bei Kündigung durch den Auftraggeber ohne wichtigen Grund sind wir berechtigt, 
            die bis dahin erbrachten Leistungen sowie entgangenen Gewinn in Rechnung zu stellen.
          </p>
        </section>

        <section>
          <h2>14. Abtretung und Übertragung</h2>
          <p>
            Die Übertragung von Rechten und Pflichten aus diesem Vertrag auf Dritte bedarf unserer 
            vorherigen schriftlichen Zustimmung.
          </p>
        </section>

        <section>
          <h2>15. Datenschutz</h2>
          <p>
            Wir verarbeiten personenbezogene Daten im Einklang mit den geltenden Datenschutzbestimmungen. 
            Nähere Informationen entnehmen Sie bitte unserer Datenschutzerklärung.
          </p>
        </section>

        <section>
          <h2>16. Streitbeilegung</h2>
          
          <h3>16.1 Online-Streitbeilegung</h3>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
            https://ec.europa.eu/consumers/odr. Unsere E-Mail-Adresse finden Sie in unserem Impressum.
          </p>

          <h3>16.2 Verbraucherschlichtungsstelle</h3>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

        <section>
          <h2>17. Schlussbestimmungen</h2>
          
          <h3>17.1 Schriftform</h3>
          <p>
            Änderungen und Ergänzungen dieser AGB sowie sämtliche Nebenabreden bedürfen zu ihrer 
            Wirksamkeit der Schriftform. Dies gilt auch für die Aufhebung des Schriftformerfordernisses.
          </p>

          <h3>17.2 Salvatorische Klausel</h3>
          <p>
            Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit 
            der übrigen Bestimmungen hiervon unberührt. Die unwirksame Bestimmung ist durch eine wirksame 
            zu ersetzen, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
          </p>

          <h3>17.3 Anwendbares Recht</h3>
          <p>
            Für alle Rechtsbeziehungen zwischen uns und dem Auftraggeber gilt das Recht der 
            Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
          </p>

          <h3>17.4 Gerichtsstand</h3>
          <p>
            Sofern der Auftraggeber Kaufmann, juristische Person des öffentlichen Rechts oder 
            öffentlich-rechtliches Sondervermögen ist, ist ausschließlicher Gerichtsstand für alle 
            Streitigkeiten aus diesem Vertrag unser Geschäftssitz.
          </p>
        </section>

        <section>
          <h2>18. Kontakt</h2>
          <p>
            Bei Fragen zu diesen Allgemeinen Geschäftsbedingungen kontaktieren Sie uns bitte:
          </p>
          <p>
            <strong>Lackfertighaus</strong><br />
            E-Mail: lackfertighaus@hotmail.com
          </p>
        </section>
      </div>
    </div>
  
    </>);
};

export default TermsConditions;